export default function BlogHero() {
  return (
    <section className="relative bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 pt-32 pb-20">
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
      
      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <div className="inline-flex items-center px-4 py-2 bg-teal-500/10 border border-teal-500/30 rounded-full mb-6">
            <i className="ri-rocket-line text-teal-400 mr-2"></i>
            <span className="text-sm font-medium text-teal-400 whitespace-nowrap">Scalability Strategy</span>
          </div>
          
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6 leading-tight">
            Surging Without Hiring: How Outsourcing Layout Work Helps Vancouver Firms Stay Lean
          </h1>
          
          <div className="flex items-center justify-center space-x-6 text-gray-300">
            <div className="flex items-center">
              <i className="ri-calendar-line mr-2"></i>
              <span className="text-sm">January 2026</span>
            </div>
            <div className="flex items-center">
              <i className="ri-time-line mr-2"></i>
              <span className="text-sm">5 min read</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
